import React, { ReactNode } from 'react';
import { FontWeight } from '../types';

export type HeaderVariants =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'h7'
  | 'h8'
  | 'h9';

export interface HeadersProps {
  children?: ReactNode;
  className?: string;
  fontWeight?: FontWeight;
  variant: HeaderVariants;
}

export const Header = ({
  children,
  className,
  fontWeight,
  variant,
}: HeadersProps): JSX.Element => {
  /* Checking for missing required props */
  // if (!variant)
  //   throw new Error(
  //     `You need to pass a prop called "variant" of type string to the Header component. To learn more about the list of required props for the
  //     Header component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/typography-card-header`
  //   );
  /* Checking for missing required props */
  /*  Styles for H1  */
  const renderH1Normal = variant === 'h1' && fontWeight === 'normal' && (
    <h2
      className={`text-h1 font-montserrat font-normal text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h2>
  );

  const renderH1Light = variant === 'h1' && fontWeight === 'light' && (
    <h2
      className={`text-h1 font-montserrat font-light text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h2>
  );

  const renderH1Medium = variant === 'h1' && fontWeight === 'medium' && (
    <h2
      className={`text-h1 font-montserrat font-medium text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h2>
  );

  const renderH1Semibold = variant === 'h1' && fontWeight === 'semibold' && (
    <h2
      className={`text-h1 font-montserrat font-semibold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h2>
  );

  const renderH1Bold = variant === 'h1' && fontWeight === 'bold' && (
    <h2
      className={`text-h1 font-montserrat font-bold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h2>
  );

  /*  Styles for H2  */
  const renderH2Normal = variant === 'h2' && fontWeight === 'normal' && (
    <h2
      className={`text-h2 font-montserrat font-normal text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h2>
  );

  const renderH2Light = variant === 'h2' && fontWeight === 'light' && (
    <h2
      className={`text-h2 font-montserrat font-light text-thryv-black-500 ${className}`}
    >
      {children}
    </h2>
  );

  const renderH2Medium = variant === 'h2' && fontWeight === 'medium' && (
    <h2
      className={`text-h2 font-montserrat font-medium text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h2>
  );

  const renderH2Semibold = variant === 'h2' && fontWeight === 'semibold' && (
    <h2
      className={`text-h2 font-montserrat font-semibold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h2>
  );

  const renderH2Bold = variant === 'h2' && fontWeight === 'bold' && (
    <h2
      className={`text-h2 font-montserrat font-bold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h2>
  );

  /*  Styles for H3  */
  const renderH3Normal = variant === 'h3' && fontWeight === 'normal' && (
    <h3
      className={`text-h3 font-montserrat font-normal text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h3>
  );

  const renderH3Light = variant === 'h3' && fontWeight === 'light' && (
    <h3
      className={`text-h3 font-montserrat font-light text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h3>
  );

  const renderH3Medium = variant === 'h3' && fontWeight === 'medium' && (
    <h3
      className={`text-h3 font-montserrat font-medium text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h3>
  );

  const renderH3Semibold = variant === 'h3' && fontWeight === 'semibold' && (
    <h3
      className={`text-h3 font-montserrat font-semibold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h3>
  );

  const renderH3Bold = variant === 'h3' && fontWeight === 'bold' && (
    <h3
      className={`text-h3 font-montserrat font-bold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h3>
  );

  /*  Styles for H4  */
  const renderH4Normal = variant === 'h4' && fontWeight === 'normal' && (
    <h4
      className={`text-h4 font-montserrat font-normal text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h4>
  );

  const renderH4Light = variant === 'h4' && fontWeight === 'light' && (
    <h4
      className={`text-h4 font-montserrat font-light text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h4>
  );

  const renderH4Medium = variant === 'h4' && fontWeight === 'medium' && (
    <h4
      className={`text-h4 font-montserrat font-medium text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h4>
  );

  const renderH4Semibold = variant === 'h4' && fontWeight === 'semibold' && (
    <h4
      className={`text-h4 font-montserrat font-semibold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h4>
  );

  const renderH4Bold = variant === 'h4' && fontWeight === 'bold' && (
    <h4
      className={`text-h4 font-montserrat font-bold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h4>
  );

  /*  Styles for H5  */
  const renderH5Normal = variant === 'h5' && fontWeight === 'normal' && (
    <h5
      className={`text-h5 font-montserrat font-${fontWeight} text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h5>
  );

  const renderH5Light = variant === 'h5' && fontWeight === 'light' && (
    <h5
      className={`text-h5 font-montserrat font-light text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h5>
  );

  const renderH5Medium = variant === 'h5' && fontWeight === 'medium' && (
    <h5
      className={`text-h5 font-montserrat font-medium text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h5>
  );

  const renderH5Semibold = variant === 'h5' && fontWeight === 'semibold' && (
    <h5
      className={`text-h5 font-montserrat font-semibold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h5>
  );

  const renderH5Bold = variant === 'h5' && fontWeight === 'bold' && (
    <h5
      className={`text-h5 font-montserrat font-bold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h5>
  );

  /*  Styles for H6  */
  const renderH6Normal = variant === 'h6' && fontWeight === 'normal' && (
    <h6
      className={`text-h6 font-montserrat font-normal text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH6Light = variant === 'h6' && fontWeight === 'light' && (
    <h6
      className={`text-h6 font-montserrat font-light text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH6Medium = variant === 'h6' && fontWeight === 'medium' && (
    <h6
      className={`text-h6 font-montserrat font-medium text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH6Semibold = variant === 'h6' && fontWeight === 'semibold' && (
    <h6
      className={`text-h6 font-montserrat font-semibold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH6Bold = variant === 'h6' && fontWeight === 'bold' && (
    <h6
      className={`text-h6 font-montserrat font-bold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  /*  Styles for H7  */
  const renderH7Normal = variant === 'h7' && fontWeight === 'normal' && (
    <h6
      className={`text-h7 font-montserrat font-normal text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH7Light = variant === 'h7' && fontWeight === 'light' && (
    <h6
      className={`text-h7 font-montserrat font-light text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH7Medium = variant === 'h7' && fontWeight === 'medium' && (
    <h6
      className={`text-h7 font-montserrat font-medium text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH7Semibold = variant === 'h7' && fontWeight === 'semibold' && (
    <h6
      className={`text-h7 font-montserrat font-semibold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH7Bold = variant === 'h7' && fontWeight === 'bold' && (
    <h6
      className={`text-h7 font-montserrat font-bold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  /*  Styles for H8  */
  const renderH8Normal = variant === 'h8' && fontWeight === 'normal' && (
    <h6
      className={`text-h8 font-montserrat font-normal text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH8Light = variant === 'h8' && fontWeight === 'light' && (
    <h6
      className={`text-h8 font-montserrat font-light text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH8Medium = variant === 'h8' && fontWeight === 'medium' && (
    <h6
      className={`text-h8 font-montserrat font-medium text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH8Semibold = variant === 'h8' && fontWeight === 'semibold' && (
    <h6
      className={`text-h8 font-montserrat font-semibold text-thryv-black-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  const renderH8Bold = variant === 'h8' && fontWeight === 'bold' && (
    <h6
      className={`text-h8 font-montserrat font-bold text-thryv-orange-500 ${className} capitalize`}
    >
      {children}
    </h6>
  );

  /*  Styles for H3  */
  const renderH9Normal = variant === 'h9' && fontWeight === 'normal' && (
    <h6
      className={`text-h9 font-montserrat font-normal text-thryv-black-500 capitalize`}
    >
      {children}
    </h6>
  );

  const renderH9Light = variant === 'h9' && fontWeight === 'light' && (
    <h6
      className={`text-h9 font-montserrat font-light text-thryv-black-500 capitalize`}
    >
      {children}
    </h6>
  );

  const renderH9Medium = variant === 'h9' && fontWeight === 'medium' && (
    <h6
      className={`text-h9 font-montserrat font-medium text-thryv-black-500 capitalize`}
    >
      {children}
    </h6>
  );

  const renderH9Semibold = variant === 'h9' && fontWeight === 'semibold' && (
    <h6
      className={`text-h9 font-montserrat font-semibold text-thryv-black-500 capitalize`}
    >
      {children}
    </h6>
  );

  const renderH9Bold = variant === 'h9' && fontWeight === 'bold' && (
    <h6
      className={`text-h9 font-montserrat font-bold text-thryv-black-500 capitalize`}
    >
      {children}
    </h6>
  );

  return (
    <>
      {renderH1Normal}
      {renderH1Light}
      {renderH1Medium}
      {renderH1Semibold}
      {renderH1Bold}
      {renderH2Normal}
      {renderH2Light}
      {renderH2Medium}
      {renderH2Semibold}
      {renderH2Bold}
      {renderH3Normal}
      {renderH3Light}
      {renderH3Medium}
      {renderH3Semibold}
      {renderH3Bold}
      {renderH4Normal}
      {renderH4Light}
      {renderH4Medium}
      {renderH4Semibold}
      {renderH4Bold}
      {renderH5Normal}
      {renderH5Light}
      {renderH5Medium}
      {renderH5Semibold}
      {renderH5Bold}
      {renderH6Normal}
      {renderH6Light}
      {renderH6Medium}
      {renderH6Semibold}
      {renderH6Bold}
      {renderH7Normal}
      {renderH7Light}
      {renderH7Medium}
      {renderH7Semibold}
      {renderH7Bold}
      {renderH8Normal}
      {renderH8Light}
      {renderH8Medium}
      {renderH8Semibold}
      {renderH8Bold}
      {renderH9Normal}
      {renderH9Light}
      {renderH9Medium}
      {renderH9Semibold}
      {renderH9Bold}
    </>
  );
};
